import Vue from 'vue'
import App from './App.vue'
import Template from './Template.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import 'bootstrap-icons/font/bootstrap-icons.css'

import { rtdbPlugin } from 'vuefire'
import { firestorePlugin } from 'vuefire'

import { config } from "../config";

import VCalendar from 'v-calendar';

// Use v-calendar & v-date-picker components
Vue.use(VCalendar);

Vue.use(firestorePlugin)
Vue.use(rtdbPlugin)
library.add(faUserSecret)
Vue.use(VueAxios, axios)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.config.productionTip = false

Vue.prototype.$e_consult_lnk = window.location.host == "localhost:8080"
? "http://localhost/e-consult/"
: "https://econsult-nontfda.moph.go.th/";

Vue.prototype.$domainfront = window.location.host == "localhost:8080"
? "http://localhost:8080"
: "https://econsult-nontfda.moph.go.th";

Vue.prototype.$domain = window.location.host == "localhost:8080"
? "http://localhost/ssj_e-consult/"
: "https://econsult-nontfda.moph.go.th/";

axios.defaults.baseURL = window.location.host == "localhost:8080"
? "http://localhost/ssj_e-consult/"
: "https://econsult-nontfda.moph.go.th/";


Vue.prototype.$dga_domain = window.location.host  == "localhost:8080"
  ? "https://connect.dga.or.th"
  : "https://connect.egov.go.th" //"https://connect.dga.or.th" // 
  
Vue.prototype.$queue_lnk = window.location.host == "localhost:8080"
? "http://localhost:8081/queue"
: "http://192.168.35.105";

Vue.prototype.$site = config.SITE;
Vue.prototype.$LINE_OA = config.LINE_OA;


Vue.prototype.$client_secret = 'IeYb8AY7Ue9' // ConsumerSecret
Vue.prototype.$client_id = 'b3bef718-f17e-433d-b569-099493016704'  // ConsumerKey

new Vue({
  router,
  store,
  Template,
  render: h => h(App)
}).$mount('#app')
